import { render, staticRenderFns } from "./pay_succ.vue?vue&type=template&id=231a818e&scoped=true&"
import script from "./pay_succ.vue?vue&type=script&lang=js&"
export * from "./pay_succ.vue?vue&type=script&lang=js&"
import style0 from "./pay_succ.vue?vue&type=style&index=0&id=231a818e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a818e",
  null
  
)

export default component.exports